import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { AppointmentTypeControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useArchiveAppointmentType = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new AppointmentTypeControllerApi(
      getConfigObject()
    ).updateAppointmentTypeArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
